import Icon from '@mui/icons-material/History';

export default function ChangesBrowserIcon(props) {
	return <Icon color={props.color} />;
}
